import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('32px')};
  margin: ${rem('60px')} 0;
`;

export const StyledReferralCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem('160px')}, 1fr));
  grid-template-rows: auto auto;
  gap: ${rem('32px')};
`;
